import { chipInk } from '../../utils/chipInk';
import { COLOR_SCALES, scaleColor } from '../../utils/colorScale';

const FIXED_RANGES = {
    rating: { min: -2, max: 2 },
};

const NUMERIC = /^[+-]?\d+([.,]\d+)?$/;

export const toNumber = (cell) => {
    const text = typeof cell === 'string' ? cell.trim() : '';

    return NUMERIC.test(text) ? Number(text.replace(',', '.')) : null;
};

export const columnRanges = (rows, skipFirstColumn = false) => {
    const ranges = [];

    rows.forEach((row) => {
        row.forEach((cell, index) => {
            if (skipFirstColumn && index === 0) {
                return;
            }

            const value = toNumber(cell);

            if (value === null) {
                return;
            }

            const range = ranges[index];

            ranges[index] = range
                ? {
                      min: Math.min(range.min, value),
                      max: Math.max(range.max, value),
                  }
                : { min: value, max: value };
        });
    });

    return ranges;
};

export const columnFilter = (columns) => {
    const numbers = (columns || '')
        .split(',')
        .map((entry) => Number(entry.trim()))
        .filter((number) => Number.isInteger(number) && number > 0);

    return numbers.length ? new Set(numbers.map((number) => number - 1)) : null;
};

export const cellColor = (cell, range, scale) => {
    const stops = COLOR_SCALES[scale];
    const value = toNumber(cell);

    if (!stops || !range || value === null) {
        return null;
    }

    const { min, max } = FIXED_RANGES[scale] || range;
    const position = max === min ? 0.5 : (value - min) / (max - min);
    const background = scaleColor(stops, position);

    return { background, ink: chipInk(background) };
};
